<template>
  <transition name="slide-fade">
    <div class="dashboard">
      <div class="container">
        <header>
          <div class="row">
            <div class="col-md-8 page-header">
              <h1>Informed Professionals</h1>
              <h3 v-if="showView == 'DASHBOARD'">Dashboard</h3>
              <h3 v-else>Referral code management</h3>
            </div>
            <div class="col-md-4 pt-3 text-right">
              <div class="form-group mt-2 col-md-12">
                <input v-model="hcpSearch" type="text" class="form-control" placeholder="Search Professionals" />
                <a href="#" @click.prevent="showAddProfessionalModal">Add a new Professional</a>
                <a v-if="showView == 'DASHBOARD'" href="#" class="pl-3" @click.prevent="showList">View Professionals</a>
                <!--<a v-else-if="hcpSearch.length < 1" href="#" @click.prevent="showDashboard" class="pl-3">View Dasboard</a>-->
              </div>

              <!--<div class="col-md-6">-->
              <!--<a @click.prevent="showAddProfessionalModal()" href="#" class="btn btn-primary">Add a professional</a>-->
              <!--</div>-->
            </div>
          </div>
        </header>

        <professional-table
          :search="hcpSearch"
          :show-data="showAddProfessional"
          @selectProfessional="viewProfessional"
        />

        <div v-if="isLoading" class="row">
          <div class="col-12 text-center">
            <font-awesome-icon :icon="['fa', 'fa-spinner']" class="fa-3x fa-fw" />
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <ModalAddInformedProfessional
        :show="showAddProfessional"
        :obj="professionalObj"
        @close="showAddProfessional = false"
      />
    </div>
  </transition>
</template>

<script>
  import UserMixins from '@/mixins/userProfile'
  import ProfessionalTable from '@/components/InformedProfessionals/professionalTable.vue'
  import ModalAddInformedProfessional from '@/components/models/ModalAddInformedProfessional'

  export default {
    name: 'Research',
    components: {
      ProfessionalTable,
      ModalAddInformedProfessional
    },
    mixins: [UserMixins],
    data: function () {
      return {
        view: 'LIST',
        hcpSearch: '',
        researcherTableSort: 'name',
        professionalObj: null,
        projectObj: null,

        showAddProfessional: false,
        showAddProject: false,

        isLoading: false
      }
    },
    computed: {
      showView() {
        if (this.view === 'DASHBOARD' && this.hcpSearch < 1) {
          return 'DASHBOARD'
        }
        return 'LIST'
      }
    },
    mounted: function () {
      this.$store.dispatch('getUser')
    },
    methods: {
      showList() {
        this.view = 'LIST'
      },
      showDashboard() {
        this.view = 'DASHBOARD'
      },
      viewProfessional(obj) {
        this.professionalObj = obj
        this.showAddProfessional = true
      },
      sortResearchersBy(col) {
        this.researcherTableSort = col
      },
      deleteProject() {
        var r = confirm('Are you sure you want to terminate this project?')
        if (r === true) {
          let self = this
          let payload = self.projectObj
          this.$store
            .dispatch('deleteProject', payload)
            .then((response) => {
              self.projectObj = null
            })
            .catch((error) => {
              console.log('Unable to terminate project', error)
            })
        }
      },
      showAddProfessionalModal() {
        this.showAddProfessional = true
        this.professionalObj = null
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .chart-wrap {
    position: relative;
    height: 200px;
    margin: 50px auto;
  }

  em {
    font-size: 17px;
    opacity: 0.7;
    max-width: 500px;
    margin: 0px auto;
  }
  .padded-row {
    padding-bottom: 0;
    @media (min-width: 992px) {
      padding-bottom: 1rem;
    }
  }

  .mb-4 {
    margin-bottom: 1.25rem !important;
    @media (min-width: 992px) {
      margin-bottom: 1.5rem !important;
    }
  }

  .table-hover tr {
    cursor: pointer;
  }

  .dashboard {
    //padding-bottom:2.5rem;
    padding-bottom: 100px;
  }

  .clickable {
    cursor: pointer;
  }
  .font-20 {
    font-size: 20px;
  }

  .page-header h1 {
    margin-bottom: 0px !important;
  }
</style>
